export const MARKETING = 'MARKETING';
export const SALES = 'SALES';
export const SERVICE = 'SERVICE';
export const CMS = 'CMS';
export const OPERATIONS = 'OPERATIONS';
export const AllProductLines = [MARKETING, SALES, SERVICE, CMS, OPERATIONS];
export const seatedProductLines = [SALES, SERVICE];